import React from 'react';
import { Box, CircularProgress } from '@mui/material';
function CircleLoader() {
    return (React.createElement(Box, { justifyContent: "center", alignItems: "center", sx: { display: 'flex', width: '100%' } },
        React.createElement(CircularProgress, { size: "2rem", color: "inherit" })));
}
export default CircleLoader;
